import React, { useContext, useEffect } from "react";
import { AppContext } from "./../contexts/AppContextProvider";
import PageContainer from "./PageContainer";
import { useHistory } from "react-router-dom";

import { Link } from "react-router-dom";
import Heading from "components/Elements/Heading.js";

const Dashboard = () => {
  const history = useHistory();
  // Get config from context
  const { currentProject, loadedConfig, config } = useContext(AppContext).state;

  useEffect(() => {
    if (
      currentProject?.projectObj?.nav?.props?.mix === true &&
      !currentProject?.boardObj
    ) {
      history.replace(`/${currentProject.project}/mix`);
    }
  }, [currentProject, history]);

  if (!loadedConfig || !config) return null;

  if (!currentProject) {
    return (
      <p>
        This Project Doesn't Exist. <br />
        <Link to="/">Go Back</Link>
      </p>
    );
  }

  // if the board wasn't found (probably trying to access a wrong page name)
  if (!currentProject.boardObj) {
    return (
      <div
        className="p-4 d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "50vh" }}
      >
        <Heading size={4} className="text-center mb-4">
          This board does not exist.
        </Heading>
        <a href="/" className="btn btn-primary">
          Return to Homepage
        </a>
      </div>
    );
  }

  return <PageContainer />;
};

export default Dashboard;
